import { BaseApiService } from './BaseApiService';

export class NewItemService extends BaseApiService {
  async getPendingNewItems(): Promise<string[]> {
    return this.get<string[]>('/api/new-items');
  }

  async acknowledgeNewItems(items: string[]): Promise<{ success: boolean; message: string; acknowledgedCount: number }> {
    return this.post<{ success: boolean; message: string; acknowledgedCount: number }>('/api/new-items/acknowledge', {
      items,
    });
  }
}

